<template>
  <!-- Using custom modal instead of Sweet Alerts' dialog for consistency across all site with elastic search -->

  <div id="st-modal" style="display: none">
    <div id="st-modal-overlay"></div>

    <div id="st-modal-container">
      <div id="st-modal-header-container">
        <section id="st-modal-header">
          <i id="st-modal-search-icon" class="fas fa-search"></i>
          <form id="st-modal-search-form">
            <input id="st-modal-search-input" placeholder="Search" />
          </form>

          <a id="st-modal-close-btn"></a>
        </section>
      </div>

      <div id="st-modal-content-container">
        <section id="st-modal-autocomplete"></section>

        <section id="st-modal-list"></section>

        <section id="st-modal-no-content"></section>
      </div>

      <div id="st-modal-footer-container"></div>
    </div>
  </div>
</template>

<script>
import "swiftype-autocomplete-jquery";

export default {
  mounted() {
    var me = this;

    me.initSearch();
  },
  methods: {
    initSearch: function () {
      const searchConfig = {
        filters: {
          page: {
            service: "!liveswitch2",
            deployment: "!server",
          },
        },
        functionalBoosts: {
          page: {
            "site-priority": "exponential",
          },
        },
      };
      const patchConfig = {
        needSearchPatch: true,
        isAutocompleteFixedOnPage: false,
        isCloudConsole: true
      };
      initializeElasticSearch(searchConfig, patchConfig);
    }
  }
};
</script>